import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchFilterData } from './outputfilterAPI';
import { RootState } from '../../state/store';

export interface FilterState {
  enabledKeys: Record<string, any[]>;
  disabledKeys: Record<string, any[]>;
  currentSelection: Record<string, any[]>;
  previousSelection: Record<string, any[]>;
  loading: boolean;
  selectedToggle: string;
  selectedViewBy: string;
}

const initialState: FilterState = {
  enabledKeys: {},
  disabledKeys: {},
  currentSelection: {},
  previousSelection: {},
  loading: false,
  selectedToggle: 'All Segment',
  selectedViewBy: 'Absolute',
};

export const fetchOutputFilters = createAsyncThunk('filters/fetchFilters', async (payload: any) => {
  const response = await fetchFilterData(payload);
  return response.data;
});

const OutputfilterSlice = createSlice({
  name: 'outputfilters',
  initialState,
  reducers: {
    resetOutputFilters: () => {
      return initialState;
    },
    updateSelection: (state, action: PayloadAction<{ key: string; value: any[] }>) => {
      const { key, value } = action.payload;
      state.currentSelection[key] = value;
    },
    syncPreviousSelection: (state) => {
      state.previousSelection = JSON.parse(JSON.stringify(state.currentSelection));
    },
    setToggle: (state, action: PayloadAction<string>) => {
      state.selectedToggle = action.payload;
    },
    setViewBy: (state, action: PayloadAction<string>) => {
      state.selectedViewBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOutputFilters.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchOutputFilters.fulfilled, (state, action) => {
      state.loading = false;
      state.enabledKeys = action.payload.enabled_keys;
      state.disabledKeys = action.payload.disabled_keys;

      state.previousSelection = { ...state.currentSelection };
    });
    builder.addCase(fetchOutputFilters.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { updateSelection, syncPreviousSelection, setToggle, setViewBy, resetOutputFilters } =
  OutputfilterSlice.actions;

export const selectEnabledKeys = (state: RootState, filterKey: string) =>
  state.outputFilters.enabledKeys[filterKey] || [];
export const selectDisabledKeys = (state: RootState, filterKey: string) =>
  state.outputFilters.disabledKeys[filterKey] || [];
export const selectLoading = (state: RootState) => state.outputFilters.loading;
export const selectSelectedToggle = (state: RootState) => state.outputFilters.selectedToggle;
export const selectSelectedViewBy = (state: RootState) => state.outputFilters.selectedViewBy;

export default OutputfilterSlice.reducer;
